var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M34.762 19.094a1.31 1.31 0 0 0-1.31 1.31v18.348h-9.174V28.268a1.31 1.31 0 0 0-1.31-1.31h-6.553a1.31 1.31 0 0 0-1.31 1.31v10.484H5.93V20.405a1.31 1.31 0 0 0-1.31-1.31H2.31L19.69 2.312l17.387 16.781h-2.316zm3.22-.942L20.602 1.37a1.304 1.304 0 0 0-1.821 0L1.4 18.151a1.31 1.31 0 0 0 .91 2.254h2.31v18.347c0 .723.586 1.31 1.31 1.31h9.173a1.31 1.31 0 0 0 1.31-1.31V28.268h6.553v10.484c0 .723.587 1.31 1.31 1.31h9.174a1.31 1.31 0 0 0 1.31-1.31V20.405h2.31a1.31 1.31 0 0 0 .911-2.253z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 20,
    strokeWidth: 0.5,
    d: "M34.762 19.094a1.31 1.31 0 0 0-1.31 1.31v18.348h-9.174V28.268a1.31 1.31 0 0 0-1.31-1.31h-6.553a1.31 1.31 0 0 0-1.31 1.31v10.484H5.93V20.405a1.31 1.31 0 0 0-1.31-1.31H2.31L19.69 2.312l17.387 16.781h-2.316zm3.22-.942L20.602 1.37a1.304 1.304 0 0 0-1.821 0L1.4 18.151a1.31 1.31 0 0 0 .91 2.254h2.31v18.347c0 .723.586 1.31 1.31 1.31h9.173a1.31 1.31 0 0 0 1.31-1.31V28.268h6.553v10.484c0 .723.587 1.31 1.31 1.31h9.174a1.31 1.31 0 0 0 1.31-1.31V20.405h2.31a1.31 1.31 0 0 0 .911-2.253z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.d6b9d3b436e07dfe3e33193fa58e78c7.svg";
export { ForwardRef as ReactComponent };